import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LoginAdministrator from '../views/LoginAdministrator.vue'
import Redirect from '../views/Redirect.vue'
import { nonEmptyString } from '../utils/util'
import store from '@/store'
import { detail as getClientDetail } from '@/api/client'
import {
  regionList as getRegionList,
  getClientActiveCls,
  getGlobalSetting
} from '@/api/common'
import { getWeiXinScan } from '@/api'
import { getAllDp } from '@/api/department'
import { traverseDpTree, traverseGoodsCategoryTree } from '@/utils/util'
import { detail as getQuarterDetail } from '@/api/quarter'
import { getDetail as getFieldDetail, getlist } from '@/api/field'
import { getAuthClientList } from '@/api/common'
import { getCategoriesList as getGoodsCategoriesList } from '@/api/goods'
import { getDetail } from '@/api/flowRule'
import { getAllFields } from '@/api/field'
import { loginDetail } from '@/api/login'
import { configurationGet } from '@/api/flow'
import { getReportSetting } from '@/api/behaviorManage'
import { getNavigationt } from '@/api/common'
import { getCustomClientFlowSetting } from '@/api/flowSetting'

import commonRouter from './common'
import mobileRouter from './common/mobile'

import {
  masterDataMaintainRouter,
  fileOperationManageRouter,
  systemSettingsRouter as masterSystemSettingsRouter
} from './master-data'

import {
  workCenterRouter,
  oaWorkManageRouter,
  behaviorStatisticReportRouter,
  performanceAppraisalManageRouter,
  complianceManageRouter,
  systemSettingsRouter as behaviorManageSystemSettingsRouter
} from './behavior-manage'

import {
  channelDeliveryManageRouter,
  flowDirectionImportRouters,
  flowIntelligentCleanRouter,
  aliasManageRouter,
  flowDirectionDataQueryRouter,
  flowStatisticAnalyRouter,
  systemSettingsRouter as butterflySystemSettingsRouter
} from './butterfly-flow-system'

import {
  orderManageRouter,
  systemSettingsRouter as businessOrderSystemSettingsRouter
} from './business-order'

import {
  deptJurisManageRouter,
  indexManageRuoter,
  systemSettingsRuouter
} from './jurisdiction-manage'

import {
  fileInfoManageRouter,
  serviceProjectManageRouter,
  systemSettingsRouter as mgSystemSettingsRouter
} from './mg'

import { earlyWarningPlatformRouter } from './earlywarning-manage'

import { abutmentManageRouter } from './abutment-module'

import { fightMapRouter, industryDataRouter } from './intelligentize-report'

import {
  basicContentManageRouter,
  costPolicyManagementRouter,
  costSettleAccountsRouter,
  financeManageRouter,
  systemSettingsRouter as costControlSystemSettingsRouter
} from './cost-control'

import { cloudVisitRouter } from './cloud-visit'

import {
  learningAssessmentManageRouters,
  systemSettingsRouter as learningPlatformSystemSettingsRouter
} from './learning-platform'

import { bonusSchemeRouter, dataManageRouter } from './bonus-computed'

import {
  yearAgreementManageRouter,
  systemSettingsRouter
} from './agreement-manage'

if (!window.VueRouter) Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch((err) => err)
}

Router.prototype.openNewWindow = function (
  routeName,
  routeParames,
  routeQuery = {}
) {
  let r = router.resolve({
    name: routeName,
    params: routeParames,
    query: routeQuery
  })
  window.open(r.href)
}
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/login-administrator',
      name: 'loginAdministrator',
      component: LoginAdministrator,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/retrieve-password',
      name: 'RetrieveThePassword',
      component: () =>
        import(
          /*webpackChunkName:"common" */
          '../views/RetrieveThePassword.vue'
        ),
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/account-activation',
      name: 'AccountActivation',
      component: () =>
        import(/*webpackChunkName:"common" */ '../views/AccountActivation.vue'),
      meta: {
        title: '账号激活'
      }
    },
    // 扫码登录微信绑定
    {
      path: '/scan-code-bindwechat',
      name: 'scanCodeBindWechat',
      component: () =>
        import(/*webpackChunkName:"user" */ '../views/scanCodeBindWechat.vue'),
      // meta: {
      //   title: '微信绑定',
      // },
      meta: {
        SecondaryMenu: '', //二级菜单
        title: '微信绑定'
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: {
        name: 'homePage'
      },
      children: [
        {
          path: '/redirect',
          name: 'redirect',
          component: Redirect
        },
        // 首页
        {
          path: '/home',
          name: 'homePage',
          component: () =>
            import(/*webpackChunkName:"homePage" */ '../views/HomePage.vue'),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '首页'
          }
        },
        // 用户

        //辖区管理系统

        // 操作日志
        {
          path: '/jurisdictionSystem/log',
          name: 'jurisdictionSystemLogPage',
          component: () =>
            import(
              /*webpackChunkName:"account" */
              '../views/jurisdictionSystem/account/LogPage.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '操作日志',
            breadcrumb: [
              {
                title: '人员管理',
                name: 'accountManage'
              }
            ]
          }
        },
        // 系统配置 （辖区管理）
        {
          path: '/jurisdictionSystem/md-setting',
          name: 'jurisdictionSystemMdSetting',
          component: () =>
            import(
              /*webpackChunkName:"departmentLabel" */
              '../views/jurisdictionSystem/md-setting.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '系统配置'
          }
        },
        {
          path: '/jurisdictionSystem/classAboutJob',
          name: 'jurisdictionSystemClassAboutJob',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemClassAboutJob" */
              '../views/jurisdictionSystem/ClassAboutJob/index.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '部门涉及职位配置',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'jurisdictionSystemMdSetting'
              }
            ]
          }
        },
        //stopQuarterSetting
        // 停用岗位配置 （辖区管理）
        {
          path: '/jurisdictionSystem/stopQuarterSetting',
          name: 'jurisdictionSystemStopQuarterSetting',
          component: () =>
            import(
              /*webpackChunkName:"departmentLabel" */
              '../views/jurisdictionSystem/stopQuarterSetting.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '停用岗位配置',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'jurisdictionSystemMdSetting'
              }
            ]
          }
        },

        // 操作记录
        {
          path: '/jurisdictionSystem/delete-log',
          name: 'deleteLog',
          component: () =>
            import(
              /*webpackChunkName:"department" */
              '../views/jurisdictionSystem/department/DeleteLog.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '操作记录',
            breadcrumb: [
              {
                title: '部门/岗位管理',
                name: 'departmentManage'
              }
            ]
          }
        },

        // 三者关系 历史关联
        {
          path: '/jurisdictionSystem/manage-history',
          name: 'jurisdictionSystemManageHistoryRecord',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemManageHistoryRecord" */
              '../views/jurisdictionSystem/manage/HistoryRecord.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '历史关联',
            breadcrumb: [
              {
                title: '岗位/产品/终端关联',
                name: 'jurisdictionManage'
              }
            ]
          }
        },

        // 公用路由界面
        ...commonRouter,
        // 主数据-主数据系统
        ...masterDataMaintainRouter,
        // 主数据-档案操作管理
        ...fileOperationManageRouter,
        // 主数据-系统设置
        ...masterSystemSettingsRouter,

        // 辖区管理
        // 部门/辖区管理
        ...deptJurisManageRouter,
        // 指标管理
        ...indexManageRuoter,
        //辖区-系统设置
        ...systemSettingsRuouter,

        // 销讯通-行为管理系统-工作中心
        ...workCenterRouter,
        // 销讯通-行为管理系统-OA办公管理
        ...oaWorkManageRouter,
        // 销讯通-行为管理系统-行为统计报表
        ...behaviorStatisticReportRouter,
        // 销讯通-行为管理系统-绩效考核管理
        ...performanceAppraisalManageRouter,
        // 销讯通-行为管理系统-合规管理
        ...complianceManageRouter,
        // 销讯通-行为管理系统-系统设置
        ...behaviorManageSystemSettingsRouter,

        // 彩蝶流向管家
        // 彩蝶流向管家-渠道发货管理
        ...channelDeliveryManageRouter,
        // 彩蝶流向管家-流向导入
        ...flowDirectionImportRouters,
        // 彩蝶流向管家-流向智能清洗
        ...flowIntelligentCleanRouter,
        //彩蝶流向管家-别名管理
        ...aliasManageRouter,
        // 彩蝶流向管家-流向数据查询
        ...flowDirectionDataQueryRouter,
        // 彩蝶流向管家-流向数据分析
        ...flowStatisticAnalyRouter,
        // 彩蝶流向管家-系统设置
        ...butterflySystemSettingsRouter,

        // 商务订单
        // 商务订单-订单/发货管理
        ...orderManageRouter,
        // 商务订单-系统设置
        ...businessOrderSystemSettingsRouter,

        // 采力
        // 采力-奖金计算
        ...bonusSchemeRouter,

        // 芒哥
        // 芒哥-档案信息管理
        ...fileInfoManageRouter,
        // 芒哥-服务项目管理
        ...serviceProjectManageRouter,
        // 芒哥-系统配置
        ...mgSystemSettingsRouter,

        // 预警管理
        // 预警平台
        ...earlyWarningPlatformRouter,

        // 对接模块
        // 对接模块-对接管理
        ...abutmentManageRouter,

        // 智能报表
        // 智能报表-作战地铁
        ...fightMapRouter,
        // 智能报表-行业数据
        ...industryDataRouter,

        // 费控系统
        // 费控系统-基础内容管理
        ...basicContentManageRouter,
        // 费控系统-费用政策管理
        ...costPolicyManagementRouter,
        // 费控系统-费用结算管理
        ...costSettleAccountsRouter,
        // 费控系统-财务管理
        ...financeManageRouter,
        // 费控系统-系统设置
        ...costControlSystemSettingsRouter,

        // 学习平台
        //学习考核管理
        ...learningAssessmentManageRouters,
        // 系统设置
        ...learningPlatformSystemSettingsRouter,

        //采力
        // 数据计算
        ...dataManageRouter,
        // 奖金计算
        ...bonusSchemeRouter,

        //云拜访
        ...cloudVisitRouter,

        // 协议管理
        // 协议管理-年度协议管理
        ...yearAgreementManageRouter,
        // 协议管理-系统设置
        ...systemSettingsRouter,

        // 主数据系统
        // 主数据明细表
        {
          path: '/masterDataSystem/masterDataSchedule',
          name: 'masterDataSchedule',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/masterDataSchedule/list.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '主数据明细表'
          }
        },

        // 主数据系统
        // 主数据明细表
        {
          path: '/flowSystem/masterDataSchedule',
          name: 'flowSystemMasterDataSchedule',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/masterDataSchedule/list.vue'
            ),
          meta: {
            SecondaryMenu: '汇总流向统计', //二级菜单
            title: '主数据明细表'
          }
        },

        // 导出定级问卷
        {
          path: '/masterDataSystem/export-rating-questionnaire',
          name: 'ExportRatingQuestionnaire',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/ExportRatingQuestionnaire.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '导出定级问卷',
            breadcrumb: [
              {
                title: '医生列表',
                name: 'clientPage'
              }
            ]
          }
        },
        // 无人负责医生查看 type 2-无人负责医生
        {
          path: '/masterDataSystem/nocharge-doctor/:cls/:type',
          name: 'nochargeDoctor',
          component: () =>
            import(
              /*webpackChunkName:"nochargeDoctor" */
              '../views/masterDataSystem/ClientPage.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '无人负责医生',
            breadcrumb: [
              {
                title: '医生列表',
                name: 'clientPage'
              }
            ]
          }
        },
        // 添加医生负责人
        {
          path: '/masterDataSystem/import-doctor-charge',
          name: 'importDoctorCharge',
          component: () =>
            import(
              /*webpackChunkName:"importDoctorCharge" */
              '../views/masterDataSystem/ImportDoctorCharge.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '添加医生负责人',
            breadcrumb: [
              {
                title: '医生列表',
                name: 'clientPage'
              },
              {
                title: '无人负责医生',
                name: 'nochargeDoctor'
              }
            ]
          }
        },
        // 天地恒一 对接日志
        {
          path: '/masterDataSystem/docking-log',
          name: 'dockingLog',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/DockingLog.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '对接日志',
            breadcrumb: [
              {
                title: '配送商',
                name: 'clientPage'
              }
            ]
          }
        },
        // 天地恒一 回款核算值导入
        {
          path: '/masterDataSystem/accounting-import',
          name: 'accountingImport',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/AccountingImport.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '回款核算值导入',
            breadcrumb: [
              {
                title: '配送商',
                name: 'clientPage'
              }
            ]
          }
        },
        // 天地恒一 协议到期商业
        {
          path: '/masterDataSystem/overdue-business',
          name: 'overdueBusiness',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/OverdueBusiness.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '协议到期商业',
            breadcrumb: [
              {
                title: '配送商',
                name: 'clientPage'
              }
            ]
          }
        },
        // 天地恒一 工业发货
        {
          path: '/flowSystem/industrial-engineering',
          name: 'industrialEngineering',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/IndustrialEngineering.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '工业发货'
          }
        },
        // 天地恒一 商业回款
        {
          path: '/flowSystem/business-return',
          name: 'businessReturn',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/BusinessReturn.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '商业回款'
          }
        },
        // 天地恒一 商业回款详情
        {
          path: '/flowSystem/business-return-detail/:client_id/:start_year/:end_year',
          name: 'businessReturnDetail',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/BusinessReturnDetail.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '应收账款详情',
            breadcrumb: [
              {
                title: '商业回款',
                name: 'businessReturn'
              }
            ]
          }
        },
        // 天地恒一 导入实际回款
        {
          path: '/flowSystem/client-return-import/:client_id/:start_year/:end_year',
          name: 'clientReturnImport',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/ClientReturnImport'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '导入实际回款',
            breadcrumb: [
              {
                title: '商业回款',
                name: 'businessReturn'
              },
              {
                title: '应收账款详情',
                name: 'businessReturnDetail'
              }
            ]
          }
        },
        // 天地恒一 商业库存分析
        {
          path: '/flowSystem/inventory-analysis',
          name: 'hyInventoryAnalysis',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/InventoryAnalysis.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '商业库存分析'
          }
        },
        // 天地恒一 商业库存明细
        {
          path: '/flowSystem/inventory-analysis-detail/:id',
          name: 'hyInventoryAnalysisDetail',
          component: () =>
            import(
              /*webpackChunkName:"hengyi" */
              '../views/masterDataSystem/hengyi/InventoryAnalysisDetail.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '商业库存明细',
            breadcrumb: [
              {
                title: '商业库存分析',
                name: 'hyInventoryAnalysis'
              }
            ]
          }
        },
        // 其它档案类型编辑 meta_type 1-添加 2-编辑
        {
          path: '/masterDataSystem/other-client-edit/:id/:type/:meta_type/:third_platform_id',
          name: 'otherClientEdit',
          component: () =>
            import(
              /*webpackChunkName:"otherClient" */
              '../views/masterDataSystem/OtherClientEdit.vue'
            ),
          async beforeEnter (to, from, next) {
            await getlist(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data.title_list) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientFields', res.data)
              }
            })
            await getAllFields(to.params.type).then((res) => {
              if (0 === res.status) {
                // 去除关联档案控件
                // let target = res.data.filter((item) => item.type != 20)
                let target = res.data.filter(
                  (item) =>
                    item.type != 20 ||
                    (item.type == 20 && item.relation_type == 2)
                )
                for (let item of target) {
                  if (item.type == 20) {
                    item.client_id_20 = ''
                    item.clientList = []
                  }
                }

                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of target) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientAllFields', target ? target : [])
              }
            })
            if (to.params.meta_type == '1') {
              store.commit('setClientDetail', {
                clientRow: {
                  name: '',
                  regionIdList: [],
                  address: '',
                  client_level_id: [''],
                  doctor_position_id: '',
                  doctor_title_id: '',
                  doctor_level_id: ''
                },
                clientCustomOptionsList: [],
                doctorGoodsList: [],
                doctorLevelList: [],
                doctorHospitalList: []
              })
            } else {
              await getClientDetail(to.params.id, to.params.type).then(
                (res) => {
                  if (0 === res.status) {
                    store.commit('setClientDetail', res.data)
                  } else {
                    store.commit('setClientDetail', {
                      clientRow: {
                        name: '',
                        regionIdList: [],
                        address: '',
                        client_level_id: [''],
                        doctor_position_id: '',
                        doctor_title_id: '',
                        doctor_level_id: ''
                      },
                      clientCustomOptionsList: [],
                      doctorGoodsList: [],
                      doctorLevelList: [],
                      doctorHospitalList: []
                    })
                  }
                }
              )
            }
            // 获省市区
            await getRegionList('0', '0').then((res) => {
              if (0 === res.status) {
                store.commit('setRegionList', res.data.regionList)
                next()
              }
            })
          },
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '终端编辑',
            breadcrumb: [
              {
                title: '终端列表',
                name: 'clientPage'
              }
            ]
          }
        },

        // 档案异步导入列表  可以删除
        {
          path: '/masterDataSystem/async/client-import',
          name: 'clientAsyncUploadList',
          component: () =>
            import(
              /*webpackChunkName:"clientOperation" */
              '../views/masterDataSystem/ClientAsyncUploadList.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '上传列表'
          }
        },
        // 导入关联关系
        {
          path: '/masterDataSystem/import-relation/:cls',
          name: 'importRelation',
          component: () =>
            import(
              /*webpackChunkName:"clientOperation" */
              '../views/masterDataSystem/ImportRelation.vue'
            ),
          meta: {
            SecondaryMenu: '批量操作', //二级菜单
            title: '导入关联关系',
            breadcrumb: [
              {
                title: '档案操作',
                name: 'clientImportList'
              }
            ]
          }
        },
        // 价 meta_type 1 3 4康恩贝
        {
          path: '/masterDataSystem/knb-price-map-page/:meta_type',
          name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
          component: () =>
            import(
              /*webpackChunkName:"unitPriceOfProduct" */
              '../views/masterDataSystem/goods/unitPriceSetting/knbPriceMapPage.vue'
            ),
          meta: {
            SecondaryMenu: '产品库', //二级菜单
            isMoreMeta: true,
            1: {
              title: '价格体系1',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                }
              ]
            },
            3: {
              title: '价格体系3',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                }
              ]
            },
            4: {
              title: '价格体系4',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                }
              ]
            }
          }
        },
        // 价批量设置 meta_type 1 3 4康恩贝
        {
          path: '/masterDataSystem/knb-goods-price-batch-setting/:meta_type',
          name: 'masterDataSystemGoodsPriceKnbBatchSetting',
          component: () =>
            import(
              /*webpackChunkName:"unitPriceOfProduct" */
              '../views/masterDataSystem/goods/unitPriceSetting/knbBatchSetting.vue'
            ),
          meta: {
            SecondaryMenu: '产品库', //二级菜单
            isMoreMeta: true,
            1: {
              title: '批量设置价格体系1',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系1',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 1
                  }
                }
              ]
            },
            3: {
              title: '批量设置价格体系3',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系3',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 3
                  }
                }
              ]
            },
            4: {
              title: '批量设置价格体系4',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系4',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 4
                  }
                }
              ]
            }
          }
        },

        // 生效价 meta_type 1 3 4康恩贝
        {
          path: '/masterDataSystem/knb-goods-effective-price/:meta_type/:id',
          name: 'masterDataSystemGoodsKnbEffectivePrice',
          component: () =>
            import(
              /*webpackChunkName:"unitPriceOfProduct" */
              '../views/masterDataSystem/goods/unitPriceSetting/knbEffectivePrice.vue'
            ),
          meta: {
            SecondaryMenu: '产品库', //二级菜单
            isMoreMeta: true,
            1: {
              title: '生效价格体系1',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系1',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 1
                  }
                }
              ]
            },
            3: {
              title: '生效价格体系3',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系3',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 3
                  }
                }
              ]
            },
            4: {
              title: '生效价格体系4',
              breadcrumb: [
                {
                  title: '产品管理',
                  name: 'goodsManage'
                },
                {
                  title: '产品单价设置',
                  name: 'masterDataSystemGoodsUnitPriceSetting'
                },
                {
                  title: '价格体系4',
                  name: 'masterDataSystemGoodsUnitPriceknbPriceMapPage',
                  params: {
                    meta_type: 4
                  }
                }
              ]
            }
          }
        },

        // 关联关系维护-kbn
        {
          path: '/jurisdictionSystem/incidence-relation-page',
          name: 'masterDataSystemIncidenceRelationPage',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
              '../views/masterDataSystem/incidence-relation/page.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '关联关系维护'
          }
        },
        // saas --关联关系维护导入-kbn
        {
          path: '/masterDataSystem/incidence-relation/operation-log',
          name: 'masterDataSystemIncidenceRelationOperationLog',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
              '../views/masterDataSystem/incidence-relation/OperationLog.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '操作日志',
            breadcrumb: [
              {
                title: '关联关系维护',
                name: 'masterDataSystemIncidenceRelationPage'
              }
            ]
          }
        },
        // 关联关系维护导入-kbn
        {
          path: '/masterDataSystem/incidence-relation-import/:json',
          name: 'masterDataSystemIncidenceRelationImport',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
              '../views/masterDataSystem/incidence-relation/import.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '导入关联关系',
            breadcrumb: [
              {
                title: '关联关系维护',
                name: 'masterDataSystemIncidenceRelationPage'
              }
            ]
          }
        },
        // 关联关系维护 1添加 2编辑
        {
          path: '/masterDataSystem/incidence-relation-edit/:meta_type',
          name: 'masterDataSystemIncidenceRelationEdit',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
              '../views/masterDataSystem/incidence-relation/edit.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '关联关系维护',

            1: {
              breadcrumb: [
                {
                  title: '关联关系维护',
                  name: 'masterDataSystemIncidenceRelationPage'
                }
              ],
              title: '添加关联关系',
              name: 'masterDataSystemIncidenceRelationPage'
            },
            2: {
              breadcrumb: [
                {
                  title: '关联关系维护',
                  name: 'masterDataSystemIncidenceRelationPage'
                }
              ],
              title: '编辑关联关系',
              name: 'masterDataSystemIncidenceRelationPage'
            }
          }
        },

        // 扣减明细维护
        {
          path: '/jurisdictionSystem/deduction-page',
          name: 'masterDataSystemDeductionPage',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
              '../views/masterDataSystem/deduction/page.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '扣减明细维护'
          }
        },
        {
          path: '/flowSystem/deduction-page',
          name: 'flowSystemDeductionPage',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
              '../views/masterDataSystem/deduction/page.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '扣减明细维护'
          }
        },
        // 扣减明细维护-导入扣减明细
        {
          path: '/masterDataSystem/deduction-import',
          name: 'masterDataSystemDeductionImport',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
              '../views/masterDataSystem/deduction/importKnbDeduction.vue'
            ),
          meta: {
            SecondaryMenu: '渠道发货分析', //二级菜单
            title: '导入扣减明细',
            breadcrumb: [
              {
                title: '扣减明细维护',
                name: 'flowSystemDeductionPage'
              }
            ]
          }
        },
        {
          path: '/masterDataSystem/grading-questionnaire-setting',
          name: 'masterDataGradingQuestionnaireSetting',
          component: () =>
            import(
              /*webpackChunkName:"field" */
              '../views/masterDataSystem/setting/GradingQuestionnaireSetting.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '定级问卷设置',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'masterDataSettingManage'
              },
              {
                title: '医生等级配置',
                name: 'masterDataDoctorLevelConfig'
              }
            ]
          }
        },
        {
          path: '/masterDataSystem/set-up-questionnaire/:id/:ids',
          name: 'masterDataSetUpQuestionnaire',
          component: () =>
            import(
              /*webpackChunkName:"field" */
              '../views/masterDataSystem/setting/SetUpQuestionnaire.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '设置问卷',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'masterDataSettingManage'
              },
              {
                title: '医生等级配置',
                name: 'masterDataDoctorLevelConfig'
              },
              {
                title: '定级问卷设置',
                name: 'masterDataGradingQuestionnaireSetting'
              }
            ]
          }
        },
        // 操作日志 type 1-系统配置入口，2-流向操作日志
        {
          path: '/flowSystem/fs-log/:type',
          name: 'flowSystemLogPage',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemConfig2" */
              '../views/flowSystem/LogPage.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '操作日志',
            breadcrumb: {
              1: [
                {
                  title: '系统配置',
                  name: 'flowSystemConfig'
                }
              ],
              2: [
                {
                  title: '流向操作',
                  name: 'flowSystemOperations'
                }
              ]
            }
          }
        },
        // 系统自检（彩蝶）
        {
          path: '/flowSystem/system-self-test',
          name: 'flowSystemSelfTest',
          component: () =>
            import('../views/flowSystem/system-self-test/List.vue'),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '系统自检'
          }
        },
        // 系统自检（彩蝶） 详情
        {
          path: '/flowSystem/system-self-test-detail/:id/:type',
          name: 'flowSystemSystemSelfTestDetail',
          component: () =>
            import('../views/flowSystem/system-self-test/Detail.vue'),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '自检详情',
            breadcrumb: [
              {
                title: '系统自检',
                name: 'flowSystemSelfTest'
              }
            ]
          }
        },
        // 系统自检（彩蝶） 自检设置
        {
          path: '/flowSystem/system-self-test-detailedit',
          name: 'flowSystemSystemSelfTestEdit',
          component: () =>
            import('../views/flowSystem/system-self-test/Edit.vue'),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '自检设置',
            breadcrumb: [
              {
                title: '系统自检',
                name: 'flowSystemSelfTest'
              }
            ]
          }
        },
        // 我的下载
        {
          path: '/user/my-download',
          name: 'flowSystemMyDownload',
          component: () =>
            import(
              /*webpackChunkName:"flowSystem4" */
              '../views/flowSystem/MyDownload.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '我的下载'
          }
        },

        // 考核区域销售统计
        {
          path: '/flowSystem/assessment-area-statistics',
          name: 'flowSystemStatisticsAssessmentArea',
          component: () =>
            import(
              /*webpackChunkName:"yanan" */
              '../views/flowSystem/statistics/AssessmentArea.vue'
            ),
          meta: {
            SecondaryMenu: '公司流向统计', //二级菜单
            title: '考核区域销售统计'
          },
          beforeEnter (to, from, next) {
            getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
              if (0 === res.status) {
                let classList = res.data.classList
                store.commit('setClientClassList', classList)
              }
              next()
            })
          }
        },
        // 商业库存分析 筛选省
        {
          path: '/flowSystem/view-inventory-statistics/:regionId',
          name: 'flowSystemStatisticsViewInventory',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemStatistics2" */
              '../views/flowSystem/statistics/ViewInventory.vue'
            ),
          meta: {
            SecondaryMenu: '商业流向维度', //二级菜单
            title: '商业库存分析'
          }
        },
        // 商业库存分析 筛选省 明细
        {
          path: '/flowSystem/view-inventory-statistics-detail/:client_id/:date/:regionId',
          name: 'flowSystemStatisticsViewInventoryDetail',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemStatistics2" */
              '../views/flowSystem/statistics/ViewInventoryDetail.vue'
            ),
          meta: {
            SecondaryMenu: '商业流向维度', //二级菜单
            title: '商业库存分析明细',
            breadcrumb: [
              {
                title: '商业库存分析',
                name: 'flowSystemStatisticsViewInventory'
              }
            ]
          }
        },

        // 纯销汇总表
        {
          path: '/flowSystem/summary/sales-summary',
          name: 'flowSystemSummarySalesSummary',
          component: () =>
            import('../views/flowSystem/summary/SalesSummary.vue'),
          meta: {
            SecondaryMenu: '汇总流向统计', //二级菜单
            title: '纯销汇总表'
          }
        },
        // 客户进销存表
        {
          path: '/flowSystem/summary/flow-distribution',
          name: 'flowSystemSummaryFlowDistribution',
          component: () =>
            import('../views/flowSystem/summary/FlowDistribution.vue'),
          meta: {
            SecondaryMenu: '汇总流向统计', //二级菜单
            title: '客户进销存表'
          }
        },
        // 客户纯销汇总表
        {
          path: '/flowSystem/customer-puresales-summary-statistics',
          name: 'flowSystemStatisticsCustomerPureSalesSummary',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemStatistics3" */
              '../views/flowSystem/statistics/CustomerPureSalesSummary.vue'
            ),
          meta: {
            SecondaryMenu: '汇总流向统计', //二级菜单
            title: '客户纯销汇总表'
          }
        },
        // 服务商纯销表
        {
          path: '/flowSystem/service-provider-puresales-statistics',
          name: 'flowSystemStatisticsServiceProviderPureSales',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemStatistics3" */
              '../views/flowSystem/statistics/ServiceProviderPureSales.vue'
            ),
          meta: {
            SecondaryMenu: '汇总流向统计', //二级菜单
            title: '服务商纯销表'
          }
        },

        // 操作日志 行为管理
        // meta_type -1 特殊客户属性
        {
          path: '/masterDataSystem/special-operation-log/:meta_type',
          name: 'masterDataSystemSpecialOperationLog',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageOperationLog" */
              '../views/masterDataSystem/OperationLog.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '操作日志'
          }
        },
        // 行为管理 首页配置 仪表盘配置
        {
          path: '/behaviorManage/homeAndGaugeDeploy/:meta_type',
          name: 'behaviorManageHomeAndGaugeDeploy',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManage1" */
              '../views/behaviorManage/homeAndGaugeDeploy.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            1: {
              title: '首页配置',
              breadcrumb: [
                {
                  title: '移动端界面配置',
                  name: 'behaviorManageMobileTerminalDeploy'
                }
              ]
            },
            2: {
              title: '仪表盘配置',
              breadcrumb: [
                {
                  title: '移动端界面配置',
                  name: 'behaviorManageMobileTerminalDeploy'
                }
              ]
            }
          }
        },
        // 审批设置
        {
          path: '/behaviorManage/approval',
          name: 'behaviorManageApprovalIndex',
          component: () =>
            import(
              /*webpackChunkName:"functionModuleDeploy" */
              '../views/behaviorManage/approval/Index.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '审批设置'
          }
        },
        // 查看销售阶段
        {
          path: '/behaviorManage/sales-visiting/salesStageList',
          name: 'behaviorManageSalesVisitingSalesStageList',
          component: () =>
            import(
              /*webpackChunkName:"departmentLabel" */
              '../views/behaviorManage/visiting/SalesStageList.vue'
            ),
          meta: {
            SecondaryMenu: '拜访活动', //二级菜单
            title: '查看销售阶段',
            breadcrumb: [
              {
                title: '拜访列表',
                path: '/behaviorManage/visiting/1'
              }
            ]
          }
        },
        // 查看销售阶段详情
        {
          path: '/behaviorManage/sales-visiting/salesStageList/detail/:quarter_id',
          name: 'behaviorManageSalesVisitingSalesStageDetail',
          component: () =>
            import(
              /*webpackChunkName:"departmentLabel" */
              '../views/behaviorManage/visiting/SalesStageDetail.vue'
            ),
          meta: {
            SecondaryMenu: '拜访活动', //二级菜单
            title: '查看销售阶段详情',
            breadcrumb: [
              {
                title: '拜访列表',
                path: '/behaviorManage/visiting/1'
              },
              {
                title: '查看销售阶段',
                path: '/behaviorManage/sales-visiting/salesStageList'
              }
            ]
          }
        },

        // 档案字段管理 操作设置
        {
          path: '/masterDataSystem/operation-set/:id/:name/:arrids/:type',
          name: 'masterDataSystemOperationSet',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemOperationSet" */
              '../views/masterDataSystem/operationSet.vue'
            ),
          meta: {
            SecondaryMenu: '批量操作', //二级菜单
            title: '操作设置',
            breadcrumb: [
              {
                title: '档案字段管理',
                name: 'fieldManage'
              },
              {
                title: '档案字段列表',
                name: 'fieldPage'
              }
            ]
          }
        },

        // 行为管理 工作报告配置 查看其他人员  暂时隐藏，路由不迁移
        {
          path: '/behaviorManage/week-rests-personnel',
          name: 'behaviorManageWorkWeekRestsPersonnel',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManage4" */
              '../views/behaviorManage/workReport/WeekRestsPersonnel.vue'
            ),
          meta: {
            SecondaryMenu: '工作报告', //二级菜单
            title: '查看其他人员',
            breadcrumb: [
              {
                title: '工作周报',
                name: 'behaviorManageWorkWorkReportWeek'
              }
            ]
          }
        },

        // 行为管理 月报 查看其他人员   暂时隐藏，路由不迁移
        {
          path: '/behaviorManage/month-rests-personnel',
          name: 'behaviorManageWorkMonthRestsPersonnel',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManage4" */
              '../views/behaviorManage/workReport/MonthRestsPersonnel.vue'
            ),
          meta: {
            SecondaryMenu: '工作报告', //二级菜单
            title: '查看其他人员',
            breadcrumb: [
              {
                title: '工作月报',
                name: 'behaviorManageWorkWorkReportMonth'
              }
            ]
          }
        },
        // 辖区关系匹配 - 问题数据
        {
          path: '/jurisdictionSystem/problem-data/:id',
          name: 'jurisdictionSystemProblemData',
          component: () =>
            import(
              /*webpackChunkName:"areaOfResponsibility" */
              '../views/jurisdictionSystem/areaOfResponsibility/ProblemData.vue'
            ),
          meta: {
            SecondaryMenu: '辖区关系', //二级菜单
            title: '问题数据',
            breadcrumb: [
              {
                title: '辖区关系匹配',
                name: 'areaOfResponsibilityRelevance'
              }
            ]
          }
        },
        // 延安和附属管理员 特殊客户属性导入
        {
          path: '/masterDataSystem/specialClientImport',
          name: 'masterDataSystemSpecialClientImport',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemSpecialClientImport" */
              '../views/masterDataSystem/specialClientImport.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '特殊客户属性导入',
            breadcrumb: [
              {
                title: '特殊客户属性',
                name: 'masterDataSystemSpecialClient'
              }
            ]
          }
        },
        // 延安 特殊客户属性
        {
          path: '/masterDataSystem/special-client',
          name: 'masterDataSystemSpecialClient',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemSpecialClientImport" */
              '../views/masterDataSystem/yanan/SpecialClient.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '特殊客户属性'
          }
        },
        // 延安功能 考核区域管理
        {
          path: '/jurisdictionSystem/assess-district-manage',
          name: 'jurisdictionSystemAssessDistrictManage',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemAssessDistrictManage" */
              '../views/jurisdictionSystem/AssessDistrictManage.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '考核区域管理'
          }
        },
        // 延安功能 考核区域管理  考核区域导入
        {
          path: '/jurisdictionSystem/assess-district-Import',
          name: 'jurisdictionSystemAssessDistrictImport',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemAssessDistrictImport" */
              '../views/jurisdictionSystem/AssessDistrictImport.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '考核区域导入',
            breadcrumb: [
              {
                title: '考核区域管理',
                name: 'jurisdictionSystemAssessDistrictManage'
              }
            ]
          }
        },
        // 终端指标分配2
        {
          path: '/jurisdictionSystem/client-target-import-plan2',
          name: 'jurisdictionSystemClientTargetImport',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemTarget" */
              '../views/jurisdictionSystem/target/ClientTargetImportPlan2.vue'
            ),
          meta: {
            SecondaryMenu: '档案指标', //二级菜单
            title: '档案指标分配'
          }
        },

        // 指标统计 详情
        {
          path: '/jurisdictionSystem/target-statistics-detail/:meta_type',
          name: 'jurisdictionSystemClientTargetStatisticsDetail',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemTarget" */
              '../views/jurisdictionSystem/target/StatisticsDetail'
            ),
          meta: {
            SecondaryMenu: '销售指标', //二级菜单
            isMoreMeta: true,
            1: {
              title: '按部门统计详情',
              breadcrumb: [
                {
                  title: '按部门统计',
                  name: 'jurisdictionSystemClientTargetStatistics'
                }
              ]
            },
            2: {
              title: '按终端统计详情',
              breadcrumb: [
                {
                  title: '按终端统计',
                  name: 'jurisdictionSystemClientTargetStatistics'
                }
              ]
            },
            3: {
              title: '按产品统计详情',
              breadcrumb: [
                {
                  title: '按产品统计',
                  name: 'jurisdictionSystemClientTargetStatistics'
                }
              ]
            }
          }
        },
        // 客户指标管理 页面指标分配
        {
          path: '/jurisdictionSystem/new-saleindex/page-index-allocation',
          name: 'jurisdictionSystemNewSaleindexPageIndexAllocation',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemTarget" */
              '../views/jurisdictionSystem/newSaleindex/PageIndexAllocation.vue'
            ),
          meta: {
            SecondaryMenu: '客户指标管理', //二级菜单
            isMoreMeta: true,
            title: '页面指标分配'
          }
        },

        // 客户指标管理 导入指标
        {
          path: '/jurisdictionSystem/new-saleindex/import-indicators',
          name: 'jurisdictionSystemNewSaleindexImportIndicators',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemTarget" */
              '../views/jurisdictionSystem/newSaleindex/ImportIndicators'
            ),
          meta: {
            SecondaryMenu: '客户指标管理', //二级菜单
            title: '导入指标',
            breadcrumb: [
              {
                title: '销售指标分配',
                name: 'jurisdictionSystemNewSaleindexPageIndexAllocation'
              }
            ]
          }
        },
        // 延安和附属管理员 终端备案导入
        {
          path: '/masterDataSystem/record-client-import',
          name: 'masterDataSystemRecordClientImport',
          component: () =>
            import(
              /*webpackChunkName:"recordClient" */
              '../views/masterDataSystem/RecordClientImport.vue'
            ),
          meta: {
            SecondaryMenu: '批量操作', //二级菜单
            title: '终端备案导入',
            breadcrumb: [
              {
                title: '档案操作',
                name: 'clientImportList'
              }
            ]
          }
        },
        // 延安和附属管理员 历史备案档案导出
        {
          path: '/masterDataSystem/record-client-history-export',
          name: 'masterDataSystemRecordClientHistoryExport',
          component: () =>
            import(
              /*webpackChunkName:"recordClient" */
              '../views/masterDataSystem/RecordClientHistoryExport.vue'
            ),
          meta: {
            SecondaryMenu: '批量操作', //二级菜单
            title: '历史备案档案导出',
            breadcrumb: [
              {
                title: '档案操作',
                name: 'clientImportList'
              }
            ]
          }
        },
        // 延安 自定义计算规则配置
        {
          path: '/flowSystem/custom-count-rule',
          name: 'masterDataSystemCustomCountRule',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemCustomCountRule" */
              '../views/masterDataSystem/yanan/CustomCountRule.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '自定义计算规则配置',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'flowSystemConfig'
              }
            ]
          }
        },
        // 编辑开发阶段
        {
          path: '/behaviorManage/edit-phases/:template_id/:name',
          name: 'behaviorManageEditPhases',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageNewHospitalExploit" */
              '../views/behaviorManage/newHospital/EditPhases.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '编辑开发阶段',
            breadcrumb: [
              {
                title: '功能模块配置',
                name: 'functionModuleDeploy'
              },
              {
                title: '新医院开发配置',
                name: 'behaviorManageNewHospitalExploit'
              },
              {
                title: '阶段配置',
                name: 'behaviorManagePhaseConfig'
              }
            ]
          }
        },
        // 审批流程设置
        {
          path: '/behaviorManage/new-hospital/approval/:meta_type',
          name: 'behaviorManageNewHospitalApproval',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageNewHospitalExploit" */
              '../views/behaviorManage/newHospital/Approval.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            6: {
              title: '审批流程设置',
              breadcrumb: [
                {
                  title: '功能模块配置',
                  name: 'functionModuleDeploy'
                },
                {
                  title: '新医院开发配置',
                  name: 'behaviorManageNewHospitalExploit'
                }
              ]
            },
            10: {
              title: '审批流程设置',
              breadcrumb: [
                {
                  title: '功能模块配置',
                  name: 'functionModuleDeploy'
                },
                {
                  title: '医院上量',
                  name: 'behaviorManageOldHospitalfunset'
                }
              ]
            }
          }
        },
        // OA 日常考勤
        {
          path: '/behaviorManage/daily-attendance-list',
          name: 'behaviorManageDailyAttendanceList',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageNewHospitalExploit" */
              '../views/behaviorManage/DailyAttendance/list.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '日常考勤'
          }
        },
        // OA 考勤设置
        {
          path: '/behaviorManage/attendance-set',
          name: 'behaviorManageAttendanceSet',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageNewHospitalExploit" */
              '../views/behaviorManage/DailyAttendance/AttendanceSet.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '考勤设置'
          }
        },
        // 延安 导出考核区域
        {
          path: '/jurisdictionSystem/export-assess-area',
          name: 'jurisdictionSystemExportAssessArea',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionSystemExportAssessArea" */
              '../views/jurisdictionSystem/ExportAssessArea.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '导出考核区域',
            breadcrumb: [
              {
                title: '考核区域管理',
                name: 'jurisdictionSystemAssessDistrictManage'
              }
            ]
          }
        },
        // 主数据档案修改记录 详情 导入日志
        {
          path: '/masterDataSystem/master-redact-record/import-record-details/:client_id/:type/:priorId/:cls/:import_client_log_id/:third_platform_id',
          name: 'masterDataSystemMasterRedactimportRecordDetails',
          component: () =>
            import(
              /*webpackChunkName:"masterDataSystemMasterRedactRecord" */
              '../views/masterDataSystem/master-redact-record/importRecordDetails.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '导入修改记录详情',
            breadcrumb: [
              {
                title: '主数据档案修改记录',
                name: 'clientPage'
              }
            ]
          }
        },
        // 批量变更医生负责人
        {
          path: '/jurisdictionSystem/batch-change-doctor-charge',
          name: 'batchChangeDoctorCharge',
          component: () =>
            import(
              /*webpackChunkName:"jurisdictionImport" */
              '../views/jurisdictionSystem/BatchChangeDoctorCharge.vue'
            ),
          meta: {
            SecondaryMenu: '', //二级菜单
            title: '批量变更医生负责人'
          }
        },
        // 主数据系统  终端翻页页面  区域内
        {
          path: '/masterDataSystem/client-page-within/:cls/:type',
          name: 'clientPageWithin',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/ClientPage.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '终端列表'
          }
        },
        // 终端详情页面 from 来源 -1 普通   区域内
        // 1-多地址 2-拜访、协访详情,3-协议到期商业(天地恒一),4-商业回款(天地恒一),5-审批详情 ,6-审批中心
        // approval_id -100代理关系
        {
          path: '/masterDataSystem/client-detail-within/:id/:type/:from/:is_replace/:approval_id/:area',
          name: 'clientDetailWithin',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/ClientDetail.vue'
            ),
          async beforeEnter (to, from, next) {
            await getAllFields(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientAllFields', data)
              }
            })
            await getlist(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data.title_list) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientFields', res.data)
              }
            })
            next()
          },
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '终端详情',
            breadcrumb: [
              {
                title: '终端列表',
                name: 'clientPage'
              }
            ]
          }
        },
        // 终端详情页面 from 来源 -1 普通  审批中心
        // 1-多地址 2-拜访、协访详情,3-协议到期商业(天地恒一),4-商业回款(天地恒一),5-审批详情 ,6-审批中心
        {
          path: '/behaviorManage/client-detail/:id/:type/:from/:is_replace/:approval_id/:json',
          name: 'clientDetailApprove',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/ClientDetail.vue'
            ),
          async beforeEnter (to, from, next) {
            await getAllFields(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientAllFields', data)
              }
            })
            await getlist(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data.title_list) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientFields', res.data)
              }
            })
            next()
          },
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '终端详情',
            breadcrumb: [
              {
                title: '终端列表',
                name: 'clientPage'
              }
            ]
          }
        },
        // 流向系统-系统配置 采集数据配置-添加过滤
        {
          path: '/flowSystem/provinceCollectDataAddProduct/:goods_filter_id',
          name: 'flowSystemCollectDataAddProduct',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemConfig4" */
              '../views/flowSystem/flowCollectData/CollectDataAddProduct.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '添加采集产品管理',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'flowSystemConfig'
              },
              {
                title: '采集数据配置',
                name: 'flowSystemCollectDataSetting'
              }
            ]
          }
        },

        // 流向系统-系统配置 采集数据配置-添加过滤
        {
          path: '/flowSystem/provinceCollectDataAddFilter/:client_filter_id',
          name: 'flowSystemCollectDataAddFilter',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemConfig4" */
              '../views/flowSystem/flowCollectData/CollectDataAddFilter.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '添加过滤',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'flowSystemConfig'
              },
              {
                title: '采集数据配置',
                name: 'flowSystemCollectDataSetting'
              }
            ]
          }
        },

        // 流向系统-系统配置 采集数据配置-批量更新过滤关键字
        {
          path: '/flowSystem/provinceCollectDataBatchUpdateFilterImport',
          name: 'flowSystemCollectDataBatchUpdateFilterImport',
          component: () =>
            import(
              /*webpackChunkName:"flowSystemConfig4" */
              '../views/flowSystem/flowCollectData/BatchUpdateFilterImport.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            title: '批量更新过滤关键字',
            breadcrumb: [
              {
                title: '系统配置',
                name: 'flowSystemConfig'
              },
              {
                title: '采集数据配置',
                name: 'flowSystemCollectDataSetting'
              }
            ]
          }
        },
        // 商务订单 年度协议列表
        {
          path: '/orderSystem/agreement-list',
          name: 'orderSystemAgreementList',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/AgreementList'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            title: '年度协议管理'
          }
        },
        // 商务订单 年度协议详情
        {
          path: '/orderSystem/agreement-detail/:order_agreement_id',
          name: 'orderSystemAgreementDetail',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/AgreementDetail'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            title: '年度协议详情',
            breadcrumb: [
              {
                title: '年度协议管理',
                name: 'orderSystemAgreementList'
              }
            ]
          }
        },

        // 商务订单 操作日志
        {
          path: '/orderSystem/operation-log',
          name: 'orderSystemOperationLog',
          component: () =>
            import(
              /*webpackChunkName:"agreementSetting" */
              '../views/orderSystem/OperationLogList'
            ),
          meta: {
            SecondaryMenu: '操作日志', //二级菜单
            title: '操作日志'
          }
        },
        // 商业回款列表
        {
          path: '/orderSystem/remittance/page',
          name: 'remittancePage',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/orderSystem/remittance/Page.vue'
            ),
          meta: {
            title: '商业回款',
            breadcrumb: [
              {
                title: '商业回款'
              }
            ]
          }
        },
        //商业回款明细表
        {
          path: '/orderSystem/remittance/detailedPage',
          name: 'remittanceDetailedPage',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/orderSystem/remittance/detailedPage.vue'
            ),
          meta: {
            title: '商业回款明细表',
            breadcrumb: [
              {
                title: '商业回款'
              }
            ]
          }
        },

        // 商业回款添加
        {
          path: '/orderSystem/remittance-add',
          name: 'remittanceAdd',
          component: () =>
            import(
              /*webpackChunkName:"functionModuleDeploy" */
              '../views/orderSystem/remittance/Add.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            title: '添加回款',
            name: 'orderSystemSettingList',
            breadcrumb: [
              {
                title: '系统设置',
                name: 'orderSystemSettingList'
              },
              {
                title: '商业回款',
                name: 'orderSystemSettingList'
              }
            ]
          }
        },

        // 商业回款详情
        {
          path: '/orderSystem/remittance-detail/:remittance_id/:from/:remittance_resource_id?',
          name: 'remittanceDetail',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/orderSystem/remittance/Detail.vue'
            ),
          meta: {
            SecondaryMenu: '商业回款', //二级菜单
            name: 'remittancePage',
            title: '商业回款详情',
            breadcrumb: [
              {
                title: '商业回款',
                name: 'remittancePage'
              }
            ]
          }
        },

        // 商业回款相关配置
        {
          path: '/orderSystem/remittance-setting',
          name: 'remittanceSetting',
          component: () =>
            import(
              /*webpackChunkName:"functionModuleDeploy" */
              '../views/masterDataSystem/goods/unitPriceSetting/RemittanceSetting.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            title: '商业回款相关配置',
            name: 'orderSystemSettingList',
            breadcrumb: [
              {
                title: '系统设置',
                name: 'orderSystemSettingList'
              }
            ]
          }
        },

        // 商业回款模板配置
        {
          path: '/orderSystem/remittance-template-setting',
          name: 'remittanceTemplateSetting',
          component: () =>
            import(
              /*webpackChunkName:"functionModuleDeploy" */
              '../views/masterDataSystem/goods/unitPriceSetting/RemittanceTemplateSetting.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            title: '商业回款模板配置',
            name: 'orderSystemSettingList',
            breadcrumb: [
              {
                title: '系统设置',
                name: 'orderSystemSettingList'
              },
              {
                title: '商业回款相关配置',
                name: 'remittanceSetting'
              },
              {
                title: '商业回款模板配置'
              }
            ]
          }
        },

        // 商业回款统计列表
        {
          path: '/orderSystem/remittanceStat/page',
          name: 'remittanceStatPage',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '@/views/orderSystem/remittanceStat/Page.vue'
            ),
          meta: {
            title: '商业回款统计',
            breadcrumb: [
              {
                title: '商业回款'
              }
            ]
          }
        },
        // 商业回款统计 详情
        {
          path: '/orderSystem/remittanceStat/detail/:clientId',
          name: 'remittanceStatDetail',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '@/views/orderSystem/remittanceStat/Detail.vue'
            ),
          meta: {
            title: '商业回款统计明细',
            breadcrumb: [
              {
                title: '商业回款统计',
                name: 'remittanceStatPage'
              }
            ]
          }
        },
        // 商业指标
        {
          path: '/orderSystem/remittanceIndex/page',
          name: 'remittanceIndexPage',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '@/views/orderSystem/remittanceIndex/Page.vue'
            ),
          meta: {
            title: '商务回款指标',
            breadcrumb: [
              {
                title: '商业回款'
              }
            ]
          }
        },

        // 发/退货单
        {
          path: '/orderSystem/InvoicePage',
          name: 'orderSysteInvoicePage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/OrderList/Invoice/Page'
            ),
          meta: {
            SecondaryMenu: '发货/开票管理', //二级菜单
            title: '发/退货单'
          }
        },
        // 销售发票
        {
          path: '/orderSystem/SalesInvoicePage',
          name: 'orderSysteSalesInvoicePage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/OrderList/sale/Page.vue'
            ),
          meta: {
            SecondaryMenu: '发货/开票管理', //二级菜单
            title: '销售发票'
          }
        },
        // 商业款项统计
        {
          path: '/orderSystem/BusinessStatisticsPage',
          name: 'orderSysteBusinessStatisticsPage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/OrderList/Statistics/BusinessPage.vue'
            ),
          meta: {
            SecondaryMenu: '分析统计', //二级菜单
            title: '商业款项统计'
          }
        },
        // 发货明细统计
        {
          path: '/orderSystem/ShipmentDetails-StatisticsPage',
          name: 'orderSysteShipmentDetailsStatisticsPage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/OrderList/Statistics/ShipmentDetailsPage'
            ),
          meta: {
            SecondaryMenu: '分析统计', //二级菜单
            title: '发货明细统计'
          }
        },

        // 流向结存统计
        {
          path: '/orderSystem/business-proceeds-statistics-list',
          name: 'orderSystemBusinessProceedsStatisticsPage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/analyticStatistics/businessProceedsStatistics/Page'
            ),
          meta: {
            SecondaryMenu: '分析统计', //二级菜单
            title: '流向结存统计'
          }
        },
        //期初结余导入
        {
          path: '/orderSystem/business-proceeds-statistics/surplus-import',
          name: 'orderSystemBusinessProceedsStatisticsSurplusImport',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/analyticStatistics/businessProceedsStatistics/SurplusImport'
            ),
          meta: {
            SecondaryMenu: '分析统计', //二级菜单
            title: '期初结余导入',
            breadcrumb: [
              {
                title: '流向结存统计',
                name: 'orderSystemBusinessProceedsStatisticsPage'
              }
            ]
          }
        },

        // 终端自报
        {
          path: '/orderSystem/sales-volume-list',
          name: 'orderSystemSalesVolumePage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/terminal/salesVolume/Page'
            ),
          meta: {
            SecondaryMenu: '自报销量', //二级菜单
            title: '终端自报'
          }
        },
        // 导入终端自报
        {
          path: '/orderSystem/sales-volume-list/import',
          name: 'orderSystemSalesVolumeImport',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/terminal/salesVolume/Import'
            ),
          meta: {
            SecondaryMenu: '自报销量', //二级菜单
            title: '导入终端自报',
            breadcrumb: [
              {
                title: '终端自报',
                name: 'orderSystemSalesVolumePage'
              }
            ]
          }
        },

        // 纯销自报明细
        {
          path: '/orderSystem/sales-volume-details/:sales_report_upload_id',
          name: 'orderSystemSalesVolumeDetails',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/terminal/salesVolume/Details'
            ),
          meta: {
            SecondaryMenu: '自报销量', //二级菜单
            title: '纯销自报明细'
          }
        },

        // 商务订单 列表
        // 销售合同
        {
          path: '/orderSystem/sales-contract-page',
          name: 'orderSystemSalesContractPage',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/salesContract/Page.vue'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            title: '销售合同'
          }
        },
        // 销售合同详情
        {
          path: '/orderSystem/sales-contract-detail/:order_contract_id/:link_type',
          name: 'orderSystemSalesContractDetail',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/salesContract/Detail'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            title: '销售合同详情',
            breadcrumb: [
              {
                title: '销售合同',
                name: 'orderSystemSalesContractPage'
              }
            ]
          }
        },
        // 销售合同添加编辑 meta_type 1新增 2编辑 from 1-列表 2-详情 link_type 跳转父级
        {
          path: '/orderSystem/sales-contract-edit/:meta_type/:order_contract_id/:from/:link_type',
          name: 'orderSystemSalesContractEdit',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/salesContract/Edit.vue'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            isMoreMeta: true,
            1: {
              title: '新增销售合同',
              breadcrumb: [
                {
                  title: '销售合同',
                  name: 'orderSystemSalesContractPage'
                },
                {
                  title: '销售合同详情',
                  name: 'orderSystemSalesContractDetail'
                }
              ]
            },
            2: {
              title: '编辑销售合同',
              breadcrumb: [
                {
                  title: '销售合同',
                  name: 'orderSystemSalesContractPage'
                },
                {
                  title: '销售合同详情',
                  name: 'orderSystemSalesContractDetail'
                }
              ]
            }
          }
        },

        // 商务订单 添加协议
        {
          path: '/orderSystem/add-agreement/:meta_type/:id',
          name: 'orderSystemAddAgreement',
          component: () =>
            import(
              /*webpackChunkName:"agreement" */
              '../views/orderSystem/AddAgreement'
            ),
          meta: {
            SecondaryMenu: '合作管理', //二级菜单
            isMoreMeta: true,
            1: {
              title: '新增年度协议',
              breadcrumb: [
                {
                  title: '年度协议管理',
                  name: 'orderSystemAgreementList'
                }
              ]
            },
            2: {
              title: '编辑年度协议',
              breadcrumb: [
                {
                  title: '年度协议管理',
                  name: 'orderSystemAgreementList'
                }
              ]
            }
          }
        },

        // 直辖岗位
        {
          path: '/behaviorManage/crmbehaviors-directQuarter/:json',
          name: 'crmBehaviorDirectQuarter',
          component: () =>
            import(
              /*webpackChunkName:"DirectQuarter" */
              '../views/behaviorManage/DirectQuarter'
            ),
          meta: {
            SecondaryMenu: '处方分析', //二级菜单
            title: '直辖岗位',
            breadcrumb: [
              {
                title: '经理辅导分析',
                name: 'doctorDataKpi'
              }
            ]
          }
        },

        // 商业开户
        {
          path: '/behaviorManage/open-client-page',
          name: 'behaviorManageOpenClientPage',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/behaviorManage/open-client-page/Page'
            ),
          meta: {
            SecondaryMenu: '拜访活动', //二级菜单
            title: '商业开户'
          }
        },
        // 商业开户详情
        {
          path: '/behaviorManage/open-client-detail/:open_client_id/:from',
          name: 'behaviorManageOpenClientDetail',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/behaviorManage/open-client-page/Detail.vue'
            ),
          meta: {
            SecondaryMenu: '拜访活动', //二级菜单
            title: '商业开户详情',
            breadcrumb: [
              // {
              //   title: '商业开户',
              //   name: 'behaviorManageOpenClientPage',
              // },
              {
                title: '审批中心',
                name: 'behaviorManageApprovalCentre'
              }
            ]
          }
        },
        // 申请商业开户
        {
          path: '/behaviorManage/open-client-apply',
          name: 'behaviorManageOpenClientApply',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageBusinessGuidance" */
              '../views/behaviorManage/open-client-page/AddEdit.vue'
            ),
          meta: {
            title: '商业开户'
          }
        },

        // 商业开户审批流配置
        {
          path: '/behaviorManage/open-client-approval',
          name: 'behaviorManageOpenClientApproval',
          component: () =>
            import(
              /*webpackChunkName:"functionModuleDeploy" */
              '../views/behaviorManage/OpenClientConfig.vue'
            ),
          meta: {
            SecondaryMenu: '系统设置', //二级菜单
            isMoreMeta: true,
            title: '商业开户相关配置',
            breadcrumb: [
              {
                title: '功能模块配置',
                name: 'functionModuleDeploy'
              }
            ]
          }
        },
        //添加服务商 from 1 芒哥服务商
        {
          path: '/masterDataSystem/add-service/:id/:from',
          name: 'addService',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/service/add-service.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '添加服务商'
          },
          async beforeEnter (to, from, next) {
            await getlist(9).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data.title_list) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientFields', res.data)
              }
            })
            await getAllFields(9).then((res) => {
              if (0 === res.status) {
                // 去除关联档案控件
                let target = res.data.filter((item) => item.type != 20)
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of target) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientAllFields', target ? target : [])
              }
            })
            store.commit('setClientDetail', {
              clientRow: {
                name: '',
                regionIdList: [],
                address: '',
                client_level_id: [''],
                doctor_position_id: '',
                doctor_title_id: '',
                doctor_level_id: ''
              },
              clientCustomOptionsList: [],
              doctorGoodsList: [],
              doctorLevelList: [],
              doctorHospitalList: []
            })
            // 获省市区
            await getRegionList('0', '0').then((res) => {
              if (0 === res.status) {
                store.commit('setRegionList', res.data.regionList)
                next()
              }
            })
          }
        },

        // 服务商详情 from 1 芒哥服务商 2服务商通用版
        {
          path: '/masterDataSystem/service-details/:server_client_id/:from',
          name: 'ServiceDetails',
          component: () =>
            import(
              /*webpackChunkName:"client" */
              '../views/masterDataSystem/service/ServiceDetails.vue'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '服务商详情'
          }
        },
        // 其它档案类型编辑 meta_type 1-添加 2-编辑  (芒哥入口) from 1 芒哥
        {
          path: '/masterDataSystem/other-client-edit-mg/:id/:type/:meta_type/:from/:server_client_id',
          name: 'otherClientEditMg',
          component: () =>
            import(
              /*webpackChunkName:"otherClient" */
              '../views/masterDataSystem/OtherClientEdit.vue'
            ),
          async beforeEnter (to, from, next) {
            await getlist(to.params.type).then((res) => {
              if (0 === res.status) {
                let data = res.data
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of data.title_list) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientFields', res.data)
              }
            })
            await getAllFields(to.params.type).then((res) => {
              if (0 === res.status) {
                // 去除关联档案控件
                let target = res.data.filter((item) => item.type != 20)
                if (
                  store.state.accountInfo.quarterRow.is_admin == 1 ||
                  store.state.accountInfo.quarterRow.is_attached_admin == 1
                ) {
                  for (let item of target) {
                    item.is_create = 1
                    item.is_detail = 1
                    item.is_edit = 1
                    item.is_click = 1
                    item.is_approval = 1
                  }
                }
                store.commit('setClientAllFields', target ? target : [])
              }
            })
            if (to.params.meta_type == '1') {
              store.commit('setClientDetail', {
                clientRow: {
                  name: '',
                  regionIdList: [],
                  address: '',
                  client_level_id: [''],
                  doctor_position_id: '',
                  doctor_title_id: '',
                  doctor_level_id: ''
                },
                clientCustomOptionsList: [],
                doctorGoodsList: [],
                doctorLevelList: [],
                doctorHospitalList: []
              })
            } else {
              await getClientDetail(to.params.id).then((res) => {
                if (0 === res.status) {
                  store.commit('setClientDetail', res.data)
                } else {
                  store.commit('setClientDetail', {
                    clientRow: {
                      name: '',
                      regionIdList: [],
                      address: '',
                      client_level_id: [''],
                      doctor_position_id: '',
                      doctor_title_id: '',
                      doctor_level_id: ''
                    },
                    clientCustomOptionsList: [],
                    doctorGoodsList: [],
                    doctorLevelList: [],
                    doctorHospitalList: []
                  })
                }
              })
            }
            // 获省市区
            await getRegionList('0', '0').then((res) => {
              if (0 === res.status) {
                store.commit('setRegionList', res.data.regionList)
                next()
              }
            })
          },
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            title: '终端编辑',
            breadcrumb: [
              {
                title: '终端列表',
                name: 'clientPage'
              }
            ]
          }
        },

        // 商业采集进度 采集问题处理
        {
          path: '/flowSystem/collection-trouble',
          name: 'flowSystemCollectionTrouble',
          component: () =>
            import(
              /*webpackChunkName:"flowSystem5" */
              '../views/flowSystem/collection-trouble/TroubleList.vue'
            ),
          meta: {
            SecondaryMenu: '采集问题处理', //二级菜单
            title: '采集问题处理'
          }
        },
        //商业异常监控
        {
          path: '/flowSystem/collection-monitor',
          name: 'flowSystemCollectionMonitor',
          component: () =>
            import('../views/flowSystem/collection-monitor/page.vue'),
          meta: {
            SecondaryMenu: '商业异常监控', //二级菜单
            title: '商业异常监控'
          }
        },
        //商业异常监控/消息推送维护
        {
          path: '/flowSystem/collection-monitor/message',
          name: 'flowSystemCollectionMonitorMessage',
          component: () =>
            import('../views/flowSystem/collection-monitor/message.vue'),
          meta: {
            SecondaryMenu: '商业异常监控', //二级菜单
            title: '商业异常监控'
          }
        },
        //商业异常监控/消息推送维护/导入消息推送维护 1是导入 2是更新
        {
          path: '/flowSystem/collection-monitor/import/:meta_type',
          name: 'flowSystemCollectionMonitorImport',
          component: () =>
            import('../views/flowSystem/collection-monitor/import.vue'),
          meta: {
            SecondaryMenu: '商业异常监控', //二级菜单
            title: '商业异常监控'
          }
        },
        //商业异常监控/消息推送维护日志
        {
          path: '/flowSystem/collection-monitor/log',
          name: 'flowSystemCollectionMonitorlog',
          component: () =>
            import('../views/flowSystem/collection-monitor/log.vue'),
          meta: {
            SecondaryMenu: '商业异常监控', //二级菜单
            title: '商业异常监控'
          }
        },
        {
          path: '/masterDataSystem/add-doctor-charge/:client_id/:company_code/:doc_name',
          name: 'masterDataSystemAddDoctorCharge',
          component: () =>
            import(
              /*webpackChunkName:"behaviorManageOldHospitalSet" */
              '../views/masterDataSystem/AddDoctorCharge'
            ),
          meta: {
            SecondaryMenu: '客户档案', //二级菜单
            isMoreMeta: true,
            title: '添加医生负责人',
            breadcrumb: [
              {
                title: '医生列表',
                name: 'clientPage'
              },
              {
                title: '添加医生',
                name: 'otherClientEdit'
              }
            ]
          }
        }

        // end
      ]
    },

    ...mobileRouter,
    // 清空三者关系
    {
      path: '/wap/ClearRelationship',
      name: 'ClearRelationship',
      component: () => import('../views/wap/ClearRelationship/index.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '*',
      name: '404',
      redirect: {
        name: 'homePage'
      }
    }
  ]
})
router.beforeEach(async (to, from, next) => {
  let type = to.params.cls
  let name = to.name

  // if (name === 'scanCodeBindWechat') {
  //   let code = to.query.code
  //   let parameter = { code }
  //   getWeiXinScan(parameter).then((res) => {
  //     console.log(res, 'resssssssssssssssssss')
  //     if (0 === res.status) {
  //       // 直接登录
  //       next({
  //         name: 'home',
  //       })
  //       return
  //     } else if (1 === res.status) {
  //       this.$message.error(res.data.errmsg)
  //       // this.$router.push({ name: 'login', query: { iswechat: 1 } })
  //       next({
  //         name: 'login',
  //         query: {
  //           iswechat: 1,
  //         },
  //       })
  //     } else if (3 === res.status) {
  //       let wxdata = {}
  //       wxdata.headimgurl = res.data.headimgurl
  //       wxdata.nickname = res.data.nickname
  //       wxdata.openId = res.data.openId
  //       localStorage.setItem('wxdata', JSON.stringify(wxdata))
  //       next()
  //     } else if (4 === res.status) {
  //       this.$message.error('请重新扫码登录')
  //       // this.$router.push({ name: 'login', query: { iswechat: 1 } })
  //       next({
  //         name: 'login',
  //         query: {
  //           iswechat: 1,
  //         },
  //       })
  //     }
  //   })
  // }
  if (
    name === 'wapParticulars' ||
    name === 'wapOldDataList' ||
    name === 'monthMagazine' ||
    name === 'wapFlowDirectionQuery' ||
    name === 'wapIndustryAnaltsisCoverageRate' ||
    name === 'wapBusinessFlowLook' ||
    name === 'wappPhotoArrayTakePhoto' ||
    name === 'wapJiuxinAssessScore'
  ) {
    store.commit('setPageRouterKey', 'home' + Math.random())
  } else {
    store.commit('setPageRouterKey', 'home')
  }

  if (
    (!store.state.clientActiveCls ||
      store.state.clientActiveCls.length === 0) &&
    [
      'login',
      'loginAdministrator',
      'RetrieveThePassword',
      'AccountActivation',
      'wapParticulars',
      'monthMagazine',
      'wapOldDataList',
      'wapOldDataDetails',
      'wapVisitObjectDetails',
      'wapRecordsMap',
      'wapJiuxinAssessScore',
      'wapJiuxinAssessScore2',
      'wapJiuxinScoreRanking',
      'wapJiuxinScoreRankingSelfSupport',
      'wapQuestionnaireFill',
      'wapQuestionnaireFillTwo',
      'wapIndustryAnaltsisCoverageRate',
      'wapBusinessFlowLook',
      'wappPhotoArrayTakePhoto',
      'wappPhotoArrayIdentifyResult',
      'wappPhotoArrayPhotoDetail',
      'wappContentPush',
      'wappPhotoArrayConfirmPhoto',
      'wapArticle',
      'wapStudyExamination',
      'wapStudyExaminationDetails',
      'wapBusinessOrderqrCode',
      'wapBusinessOrderVerifyInfo',
      'wapBusinessOrderCreateBusinessOrder',
      'wapBusinessOrderSelectProcurementProducts',
      'wapBusinessOrderAddProducts',
      'wapBusinessOrderAddProductsSelect',
      'wapBusinessOrderSelectAddress',
      'wapBusinessOrderAddAddress',
      'wapBusinessOrderCreateSuccess',
      'wapNoticeDetail',
      'wapScoreIntroduce',
      'wapFlowDirectionQuery',
      'wapHelp',
      'scanCodeBindWechat'
    ].indexOf(to.name) === -1
  ) {
    await getClientActiveCls().then((res) => {
      if (0 === res.status) {
        let data = res.data
        store.commit('setClientActiveCls', data)
      }
    })
  }

  let crumbs = '首页/'
  let meta = to.meta
  //添加二级菜单
  if (meta.SecondaryMenu && typeof meta.SecondaryMenu == 'string') {
    crumbs += meta.SecondaryMenu + '/'
  }
  if (to.fullPath.includes('is_future')) {
    try {
      console.log(to.meta, 'metaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
      for (let i in to.meta) {
        if (i == 'SecondaryMenu') {
          if (to.meta['SecondaryMenu'] == '部门/岗位')
            to.meta['SecondaryMenu'] = '未来框架'
        }
        console.log(
          to.meta[i],
          'to.meta[i]to.meta[i]to.meta[i]to.meta[i]to.meta[i]to.meta[i]to.meta[i]'
        )
        if (i == 'breadcrumb') {
          for (let j of to.meta[i]) {
            // 没有嵌套的多个面包屑
            if (j.title == '部门/岗位管理') {
              j.title = '未来组织架构'
              j.name = 'futureOrganization'
            }

            if (j.title == '岗位/产品/终端关联') {
              j.title = '未来三者关系'
              j.name = 'futureRelations'
            }
          }
        } else {
          if (to.meta[i]['breadcrumb'] && to.meta[i]['breadcrumb'].length > 0) {
            // 有嵌套的多个面包屑
            for (let j of to.meta[i]['breadcrumb']) {
              if (j.title == '部门/岗位管理') {
                j.title = '未来组织架构'
                j.name = 'futureOrganization'
              }

              if (j.title == '岗位/产品/终端关联') {
                j.title = '未来三者关系'
                j.name = 'futureRelations'
              }

              // if(j.title == '')
            }
          }
        }
      }
    } catch (e) { }
  }
  console.log(to, 'toooooooooooooooooooooooooooooooooooooooo')
  if (meta.isMoreMeta && to.params.meta_type) {
    //情况一
    let crumbsObj = meta[to.params.meta_type]
    if (crumbsObj.breadcrumb) {
      for (let item of crumbsObj.breadcrumb) {
        crumbs += item.title + '/'
      }
    }
    crumbs += crumbsObj.title
  } else if (meta.breadcrumb) {
    //情况二
    let crumbsArr = meta.breadcrumb
    for (let i = 0; i < crumbsArr.length; i++) {
      crumbs += crumbsArr[i].title + '/'
    }
    crumbs += meta.title
  } else if (to.params.cls) {
    //情况三
    let clientActiveCls = store.state.clientActiveCls
    let tempData = clientActiveCls.filter((item) => item.id == type)[0]
    //移动端行业数据覆盖率传了cls 做了下判断
    if (tempData) {
      crumbs += tempData.client_name
    }
  } else {
    //情况四
    crumbs += meta.title
  }
  if (name == 'clientAdd') {
    let clientActiveCls = store.state.clientActiveCls
    let tempData = clientActiveCls.filter((item) => item.id == type)[0]
    console.log(tempData.client_name)
    crumbs =
      '首页/客户档案/' + tempData.client_name + '/添加' + tempData.client_name
  } else if (name == 'otherClientEdit') {
    let clientActiveCls = store.state.clientActiveCls
    let id = to.params.type
    let tempData = clientActiveCls.filter((item) => item.id == id)[0]
      .client_name
    let tempType = to.params.meta_type
    if (tempType == 1) {
      crumbs = '首页/客户档案/' + tempData + '列表/添加' + tempData
    } else {
      crumbs =
        '首页/客户档案/' +
        tempData +
        '/' +
        tempData +
        '详情' +
        '/编辑' +
        tempData
    }
  } else if (name == 'flowSystemMyDownload') {
    crumbs = '首页/我的下载'
  } else if (name == 'clientImport') {
    let clientActiveCls = store.state.clientActiveCls
    let tempData = clientActiveCls.filter((item) => item.id == type)[0]
    crumbs = '首页/批量操作/档案操作/导入' + tempData.client_name + '/档案导入'
  } else if (name == 'clientInfoUpdate') {
    let clientActiveCls = store.state.clientActiveCls
    let tempData = clientActiveCls.filter((item) => item.id == type)[0]
    crumbs = '首页/批量操作/档案操作/更新' + tempData.client_name + '信息'
  } else if (name == 'clientDelete') {
    let clientActiveCls = store.state.clientActiveCls
    let tempData = clientActiveCls.filter((item) => item.id == type)[0]
    crumbs =
      '首页/批量操作/档案操作/删除' +
      tempData.client_name +
      '档案/批量删除/档案删除'
  } else if (name == 'importRelation') {
    switch (type) {
      case '5':
        crumbs = '首页/批量操作/档案操作/导入自然人关联关系/档案导入'
        break
      case '6':
        crumbs = '首页/批量操作/档案操作/导入自然人关联关系/档案导入'
        break
    }
  } else if (name == 'changeClientType') {
    crumbs = '首页/批量操作/档案操作/修改档案类型'
  } else if (name == 'goodsManage') {
    crumbs = '首页/产品库/产品管理'
  } else if (name == 'masterDataSystemGoodsCategory') {
    crumbs = '首页/产品库/产品管理/产品分类'
  } else if (name == 'goodsImport') {
    crumbs = '首页/产品库/产品管理/产品导入'
  } else if (name == 'brandManage') {
    crumbs = '首页/基础信息/连锁品牌'
  } else if (name == 'chainArchitectureBatchimport') {
    crumbs = '首页/基础信息/连锁架构/批量导入连锁架构'
  } else if (name == 'brandImport') {
    crumbs = '首页/基础信息/连锁品牌/导入品牌'
  } else if (name == 'chainArchitectureBatchimport') {
    crumbs = '首页/基础信息/连锁结构/批量导入连锁架构'
  } else if (name == 'fieldPage') {
    switch (type) {
      case '1':
        crumbs = '首页/批量操作/档案字段管理/药店档案字段'
        break
      case '2':
        crumbs = '首页/批量操作/档案字段管理/医院档案字段'
        break
      case '3':
        crumbs = '首页/批量操作/档案字段管理/连锁总部档案字段'
        break
      case '4':
        crumbs = '首页/批量操作/档案字段管理/商业公司档案字段'
        break
      case '5':
        crumbs = '首页/批量操作/档案字段管理/自然人档案字段'
        break
      case '6':
        crumbs = '首页/批量操作/档案字段管理/代理商档案字段'
        break
    }
  } else if (name == 'fieldAdd') {
    switch (type) {
      case '1':
        crumbs = '首页/批量操作/档案字段管理/药店档案字段/添加字段'
        break
      case '2':
        crumbs = '首页/批量操作/档案字段管理/医院档案字段/添加字段'
        break
      case '3':
        crumbs = '首页/批量操作/档案字段管理/连锁总部案档字段/添加字段'
        break
      case '4':
        crumbs = '首页/批量操作/档案字段管理/商业公司档案字段/添加字段'
        break
      case '5':
        crumbs = '首页/批量操作/档案字段管理/自然人档案字段/添加字段'
        break
      case '6':
        crumbs = '首页/批量操作/档案字段管理/代理商档案字段/添加字段'
        break
    }
  } else if (name == 'fieldEdit') {
    crumbs = '首页/批量操作/档案字段管理/医院档案字段/编辑字段'
    let type = to.params.type
    switch (type + '') {
      case '2':
        crumbs = '首页/批量操作/档案字段管理/医院档案字段/编辑字段'
        break
      case '1':
        crumbs = '首页/批量操作/档案字段管理/药店档案字段/编辑字段'
        break
      case '3':
        crumbs = '首页/批量操作/档案字段管理/连锁总部档案字段/编辑字段'
        break
      case '4':
        crumbs = '首页/批量操作/档案字段管理/商业公司档案字段/编辑字段'
        break
      case '5':
        crumbs = '首页/批量操作/档案字段管理/自然人档案字段/编辑字段'
        break
      case '6':
        crumbs = '首页/批量操作/档案字段管理/代理商档案字段/编辑字段'
        break
    }
  } else if (name == 'masterDataImportConfig') {
    crumbs = '首页/系统配置/档案导入配置'
  } else if (name == 'subordinateAdmin') {
    crumbs = '首页/部门/岗位/部门/岗位管理/附属管理员'
  } else if (name == 'subordinateAdminGroupManage') {
    crumbs = '首页/部门/岗位/部门/岗位管理/附属管理员/分组管理'
  } else if (name == 'departmentBatchAdd') {
    crumbs = '首页/部门/岗位/部门/岗位管理/批量添加部门'
  } else if (name == 'quarterBatchAdd') {
    crumbs = '首页/部门/岗位/部门/岗位管理/批量添加岗位'
  } else if (name == 'departmentTransfer') {
    crumbs = '首页/部门/岗位/部门/岗位管理/部门迁移'
  } else if (name == 'quarterTransfer') {
    crumbs = '首页/部门/岗位/部门/岗位管理/岗位迁移'
  } else if (name == 'departmentManage') {
    crumbs = '首页/部门/岗位/部门/岗位管理'
  } else if (name == 'changeCharge') {
    crumbs = '首页/辖区关系/产品/终端关联/变更负责人'
  } else if (name == 'jurisdictionImport') {
    crumbs = '首页/辖区关系/产品/终端关联/批量操作'
  } else if (name == 'jobManage') {
    crumbs = '首页/系统设置/职位管理'
  } else if (name == 'jobEdit') {
    crumbs = '首页/系统设置/职位管理/添加职位'
  } else if (name == 'jobAdd') {
    crumbs = '首页/系统设置/职位管理/添加职位'
  } else if (name == 'accountManage') {
    crumbs = '首页/系统设置/人员管理'
  } else if (name == 'accountImport') {
    crumbs = '首页/系统设置/人员字段管理/批量导入人员'
  } else if (name == 'accountCancel') {
    crumbs = '首页 / 部门/辖区管理 / 基础信息 / 人员管理 / 已注销账号'
  } else if (name == 'jurisdictionSystemLogPage') {
    crumbs = '首页/系统设置/人员字段管理/操作日志'
  } else if (name == 'flowSystemSalesDataImport') {
    crumbs = '首页/流向导入/销售数据导入'
  } else if (name == 'flowSystemGoodsAlias') {
    crumbs = '首页/别名库/产品别名库'
  } else if (name == 'flowSystemGoodsAliasExport') {
    crumbs = '首页/别名库/产品别名库/导出产品别名'
  } else if (name == 'flowSystemGoodsAliasImport') {
    crumbs = '首页/别名库/产品别名库/导入产品别名'
  } else if (name == 'flowSystemClientAlias') {
    crumbs = '首页/别名库/档案别名库'
  } else if (name == 'flowSystemClientAliasExport') {
    crumbs = '首页/别名库/档案别名库/档案别名库导出'
  } else if (name == 'flowSystemClientAliasImport') {
    crumbs = '首页/别名库/档案别名库/档案别名库导入'
  } else if (name == 'flowSystemPendingInFlow') {
    crumbs = '首页/智能清洗/待入库数据'
  } else if (name == 'flowSystemImportTemplateConfig') {
    crumbs = '首页/系统设置/系统设置/导入模版配置'
  } else if (name == 'cleanTimeConfig') {
    crumbs = '首页/系统设置/系统设置/流向清洗时间配置'
  } else if (name == 'monthOfHistoryConfig') {
    crumbs = '首页/系统设置/系统设置/历史月份流向配置'
  } else if (name == 'countTimeConfig') {
    crumbs = '首页/系统设置/系统设置/统计账期配置'
  } else if (name == 'inventoryEditNotice') {
    crumbs = '首页/系统设置/系统设置/库存周转天数预警值'
  } else if (name == 'flowSystemFlowDelete') {
    crumbs = '首页/系统设置/系统设置/流向操作/销售数据查询/流向卸载'
  } else if (name == 'departmentBatchAdd') {
    crumbs = '首页/部门/岗位/部门/岗位管理/批量添加部门'
  } else if (name == 'clientEdit') {
    let type = to.params.type
    switch (type + '') {
      case '2':
        crumbs = '首页/客户档案/医院终端/编辑医院'
        break
      case '1':
        crumbs = '首页/客户档案/药店终端/编辑药店'
        break
      case '3':
        crumbs = '首页/客户档案/连锁总部列表/编辑连锁总部'
        break
      case '4':
        crumbs = '首页/客户档案/商业公司/编辑商业公司'
        break
      case '5':
        crumbs = '首页/客户档案/自然人/编辑自然人'
        break
      case '6':
        crumbs = '首页/客户档案/代理商/编辑代理商'
        break
    }
  } else if (name == 'clientCustomizationRulesPage') {
    crumbs = '首页/系统设置/系统配置/流向自定义清洗规则配置/删除规则'
  } else if (name == 'clientCustomizationRulesEdit') {
    crumbs = '首页/系统设置/系统配置/流向自定义清洗规则配置/编辑规则'
  } else if (name == 'clientCustomizationRulesAdd') {
    crumbs = '首页/系统设置/系统配置/流向自定义清洗规则配置/添加规则'
  } else if (name == 'flowSystemTransfer') {
    crumbs = '首页/系统设置/流向操作/流向迁移'
  } else if (name == 'batchUpdateGoods') {
    crumbs = '首页/部门/岗位/部门/岗位管理/批量更新产品'
  } else if (name == 'batchEditQuarter') {
    crumbs = '首页/部门/岗位/部门/岗位管理/批量停用/删除岗位'
  } else if (name == 'flowSystemStatisticsInventorySettings') {
    crumbs = '首页/商业流向维度/商业进销存统计/库存设置'
  } else if (name == 'flowSystemStatisticsFrequencyOfPurchase') {
    crumbs = '首页/预警统计/进货频次异常客户/异常值设置'
  } else if (name == 'flowSystemFlowQuartersChange') {
    crumbs = '首页/系统设置/流向操作/流向所属岗位变更'
  } else if (name == 'personnelFieldEdit') {
    if (to.params.meta_type == 1) {
      crumbs = '首页/系统设置/系统设置/人员字段管理/添加字段'
    } else {
      crumbs = '首页/系统设置/系统设置/人员字段管理/编辑字段'
    }
  } else if (name == 'personnelField') {
    crumbs = '首页/系统设置/人员字段管理'
  } else if (name == 'MgServiceOperationSet') {
    crumbs = '首页/系统配置/系统设置/综合服务商操作设置'
  }

  store.commit('setCrumbs', crumbs)
  //延安功能
  if (
    to.name !== 'redirect' &&
    to.name !== 'login' &&
    to.name !== 'loginAdministrator' &&
    to.name !== 'RetrieveThePassword' &&
    to.name !== 'AccountActivation' &&
    to.name != 'wapParticulars' &&
    to.name != 'monthMagazine' &&
    to.name != 'wapOldDataList' &&
    to.name != 'wapOldDataDetails' &&
    to.name != 'wapVisitObjectDetails' &&
    to.name != 'wapRecordsMap' &&
    to.name != 'wapJiuxinAssessScore' &&
    to.name != 'wapJiuxinAssessScore2' &&
    to.name != 'wapJiuxinScoreRanking' &&
    to.name != 'wapJiuxinScoreRankingSelfSupport' &&
    to.name != 'wapQuestionnaireFill' &&
    to.name != 'wapQuestionnaireFillTwo' &&
    to.name != 'wapIndustryAnaltsisCoverageRate' &&
    to.name != 'wapBusinessFlowLook' &&
    to.name != 'wappPhotoArrayTakePhoto' &&
    to.name != 'wappPhotoArrayIdentifyResult' &&
    to.name != 'wappPhotoArrayPhotoDetail' &&
    to.name != 'wappContentPush' &&
    to.name != 'wappPhotoArrayConfirmPhoto' &&
    to.name != 'wapArticle' &&
    to.name != 'wapStudyExamination' &&
    to.name != 'wapStudyExaminationDetails' &&
    to.name != 'wapBusinessOrderqrCode' &&
    to.name != 'wapBusinessOrderVerifyInfo' &&
    to.name != 'wapBusinessOrderCreateBusinessOrder' &&
    to.name != 'wapBusinessOrderSelectProcurementProducts' &&
    to.name != 'wapBusinessOrderAddProducts' &&
    to.name != 'wapBusinessOrderAddProductsSelect' &&
    to.name != 'wapBusinessOrderSelectAddress' &&
    to.name != 'wapBusinessOrderAddAddress' &&
    to.name != 'wapBusinessOrderCreateSuccess' &&
    to.name != 'wapNoticeDetail' &&
    to.name != 'wapScoreIntroduce' &&
    to.name != 'wapFlowDirectionQuery' &&
    to.name != 'wapHelp' &&
    to.name != 'scanCodeBindWechat'
  ) {
    console.log(to, ';to')

    await loginDetail(store.state.save_quarter_id).then((res) => {
      store.commit('SET_ACCOUNT_INFO', res.data)
      getNavigationt({
        quarter_id: res.data.quarterRow.quarter_id,
        web_path: to.path
      }).then((res) => {
        if (0 === res.status) {
          let subSystemList = res.data.subSystemList
          let tempArr = []
          for (let i = 0; i < subSystemList.length; i++) {
            if (subSystemList[i].subsystem_id == 14) {
              let menuList = subSystemList[i].menuList
              for (let k = 0; k < menuList.length; k++) {
                if (menuList[k].module_name == '云拜访') {
                  let subMenuList = menuList[k].subMenuList
                  try {
                    for (let j = 0; j < subMenuList.length; j++) {
                      tempArr.push(subMenuList[j].module_name)
                    }
                  } catch (e) { }
                }
              }
            }
          }
          // console.log(tempArr);
          store.commit('setCloudQuestionnaire', tempArr)
        }

        if (0 === res.status) {
          let routeMap = {
            jurisdictionSystem: '1000000',
            masterDataSystem: '2000000',
            flowSystem: '4000000',
            bonusReturnSystem: '9000000',
            behaviorManage: '3000000',
            s2pDataApi: '1300000',
            studyPlatform: '12000000',
            orderSystem: '6000000',
            outsideSystem: '1400000',
            mg: '10000000',
            intelligenceReports: '1500000',
            costControlSystem: '1600000',
            protocolManagement: '1700000',
            'earlywarning-manage': '18000000'
          }
          const MODULE_NAME_MAP = {
            1000000: '辖区管理',
            2000000: '主数据',
            4000000: '流向系统',
            8000000: 'BI分析',
            9000000: '奖金返利',
            3000000: '行为管理',
            1300000: '对接系统',
            12000000: '学习平台系统',
            6000000: '商务订单系统',
            1400000: '云拜访',
            10000000: '芒哥管理系统-工业端',
            1500000: '智能报表',
            1600000: '费控系统',
            1700000: '协议管理',
            18000000: '预警管理'
          }
          // 去除芒哥工业端
          const subSystemList = res.data.subSystemList
          store.commit('setFuncModuleArray', res.data.funcModuleArray)
          store.commit('setSubSystemList', res.data.subSystemList)
          store.commit('setModuleRow', res.data.moduleRow)
          subSystemList.map((item) => {
            item.module_int = item.module_int + ''
            if (MODULE_NAME_MAP.hasOwnProperty(item.module_int)) {
              item.module_name = MODULE_NAME_MAP[item.module_int]
            }
          })

          // 匹配当前导航
          const regExp = /^\/(\w+)\//
          const whiteList = ['earlywarning-manage'] //新增一级菜单需要在这里加入白名单，或者路由菜单驼峰或者整字母
          const path = to.path
          const pathSystem = path.split('/')[1]
          if (regExp.test(path) || whiteList.includes(pathSystem)) {
            const systemName = whiteList.includes(pathSystem)
              ? pathSystem
              : path.match(regExp)[1]
            console.log(systemName, 'systemName=========>')
            console.log(routeMap, 'routeMap==========>')
            console.log(routeMap[systemName], 'routeMap[systemName]==========>')
            if (routeMap.hasOwnProperty(systemName)) {
              store.commit('setHideNavbar', false)
              const systemInt = routeMap[systemName]
              // themeChange(systemInt + '');
              // 选中对应顶级导航
              // this.mainSelectedKeys = [systemInt];

              store.commit('setMainSelectedKeys', [systemInt])
              console.log(systemInt, 'systemInt===>')
              subSystemList.map((item) => {
                if (item.module_int === systemInt) {
                  console.log(item.menuList, 'item.menuList====?')
                  // 获取对应顶级导航下的导航数据
                  // this.menuList = item.menuList;
                  store.commit('setMenuList', item.menuList)
                  // 选中对应页面导航
                  // this.subSelectedKeys = [path];
                  store.commit('setSubSelectedKeys', [path])
                  setTimeout(() => {
                    store.commit('setGlobalLoading', false)
                  }, 500)
                }
              })
            } else if (path !== '/redirect') {
              // 为无下级导航页面 个人中心等
              store.commit('setHideNavbar', true)
              setTimeout(() => {
                store.commit('setGlobalLoading', false)
              }, 500)
            }
          } else if (path !== '/redirect') {
            // 只有一级，首页等
            store.commit('setHideNavbar', true)
            setTimeout(() => {
              store.commit('setGlobalLoading', false)
            }, 500)
            if (path === '/home') {
              // this.mainSelectedKeys = ['/home'];
              store.commit('setMainSelectedKeys', ['/home'])
            }
          }
          // 默认展开所有菜单
          let subMenuOpenKeys = []
          subSystemList.map((item) => {
            // 默认展开所有菜单
            for (let e of item.menuList) {
              subMenuOpenKeys.push(e.module_int)
            }
          })
          // this.subMenuOpenKeys = subMenuOpenKeys;
          if (!store.state.collapsed) {
            store.commit('setSubMenuOpenKeys', subMenuOpenKeys)
          }
          // this.subSystemList = subSystemList;
          subSystemList.unshift({
            module_name: '首页',
            module_int: '/home'
          })
          store.commit('setSubSystemList', subSystemList)

          // this.getWidth();
        }
      })
    })
  }

  if (
    store.state.customClientFlowSetting.length == 0 &&
    (to.name == 'flowSystemStatisticsClientPurchase' ||
      to.name == 'flowSystemStatisticsCustomerEarlyWarning' ||
      to.name == 'flowSystemStatisticsClientSales' ||
      to.name == 'flowSystemStatisticsDepartmentSales' ||
      to.name == 'flowSystemStatisticsFrequencyOfPurchase' ||
      to.name == 'flowSystemStatisticsPerMuOfClient' ||
      to.name == 'flowSystemStatisticsClientReturn' ||
      to.name == 'flowSystemStatisticsJobSales' ||
      to.name == 'flowSystemSummarySalesDetails' ||
      to.name == 'protocolManagementSettingAgreementConfig')
  ) {
    await getCustomClientFlowSetting().then((res) => {
      store.commit('setCustomClientFlowSetting', res.data)
    })
  }

  if (
    to.name != 'login' &&
    to.name != 'loginAdministrator' &&
    to.name != 'RetrieveThePassword' &&
    to.name != 'AccountActivation' &&
    to.name != 'wapParticulars' &&
    to.name != 'monthMagazine' &&
    to.name != 'wapOldDataList' &&
    to.name != 'wapOldDataDetails' &&
    to.name != 'wapVisitObjectDetails' &&
    to.name != 'wapRecordsMap' &&
    to.name != 'redirect' &&
    to.name != 'wapJiuxinAssessScore' &&
    to.name != 'wapJiuxinAssessScore2' &&
    to.name != 'wapJiuxinScoreRanking' &&
    to.name != 'wapJiuxinScoreRankingSelfSupport' &&
    to.name != 'wapQuestionnaireFill' &&
    to.name != 'wapQuestionnaireFillTwo' &&
    to.name != 'wapIndustryAnaltsisCoverageRate' &&
    to.name != 'wapBusinessFlowLook' &&
    to.name != 'wappPhotoArrayTakePhoto' &&
    to.name != 'wappPhotoArrayIdentifyResult' &&
    to.name != 'wappPhotoArrayPhotoDetail' &&
    to.name != 'wappContentPush' &&
    to.name != 'wappPhotoArrayConfirmPhoto' &&
    to.name != 'wapArticle' &&
    to.name != 'wapStudyExamination' &&
    to.name != 'wapStudyExaminationDetails' &&
    to.name != 'wapBusinessOrderqrCode' &&
    to.name != 'wapBusinessOrderVerifyInfo' &&
    to.name != 'wapBusinessOrderCreateBusinessOrder' &&
    to.name != 'wapBusinessOrderSelectProcurementProducts' &&
    to.name != 'wapBusinessOrderAddProducts' &&
    to.name != 'wapBusinessOrderAddProductsSelect' &&
    to.name != 'wapBusinessOrderSelectAddress' &&
    to.name != 'wapBusinessOrderAddAddress' &&
    to.name != 'wapBusinessOrderCreateSuccess' &&
    to.name != 'wapNoticeDetail' &&
    to.name != 'wapScoreIntroduce' &&
    to.name != 'wapFlowDirectionQuery' &&
    to.name != 'wapHelp' &&
    to.name != 'scanCodeBindWechat'
  ) {
    //获取医生定级方式
    await getGlobalSetting(7).then((res) => {
      store.commit('setDoctorLevelType', res.data.config)
    })
    //获取问卷定级开启关闭 1开启2关闭
    await getGlobalSetting(37).then((res) => {
      store.commit('setDoctorLevelQuestionnaireIsOpen', res.data.config)
    })
  }
  if (store.state.clientActiveCls && store.state.clientActiveCls.length > 0) {
    if (
      to.name === from.name ||
      (to.meta.title && to.meta.title === from.meta.title)
    ) {
      next({
        name: 'redirect',
        query: {
          toPath: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (
    to.name == 'login' ||
    to.name == 'loginAdministrator' ||
    to.name == 'RetrieveThePassword' ||
    to.name == 'AccountActivation' ||
    to.name == 'wapParticulars' ||
    to.name == 'monthMagazine' ||
    to.name == 'wapOldDataList' ||
    to.name == 'wapOldDataDetails' ||
    to.name == 'wapVisitObjectDetails' ||
    to.name == 'wapRecordsMap' ||
    to.name == 'wapJiuxinAssessScore' ||
    to.name == 'wapJiuxinAssessScore2' ||
    to.name == 'wapJiuxinScoreRanking' ||
    to.name == 'wapJiuxinScoreRankingSelfSupport' ||
    to.name == 'wapQuestionnaireFill' ||
    to.name == 'wapQuestionnaireFillTwo' ||
    to.name == 'wapIndustryAnaltsisCoverageRate' ||
    to.name == 'wapBusinessFlowLook' ||
    to.name == 'wappPhotoArrayTakePhoto' ||
    to.name == 'wappPhotoArrayIdentifyResult' ||
    to.name == 'wappPhotoArrayPhotoDetail' ||
    to.name == 'wappContentPush' ||
    to.name == 'wappPhotoArrayConfirmPhoto' ||
    to.name == 'wapArticle' ||
    to.name == 'wapStudyExamination' ||
    to.name == 'wapStudyExaminationDetails' ||
    to.name == 'wapBusinessOrderqrCode' ||
    to.name == 'wapBusinessOrderVerifyInfo' ||
    to.name == 'wapBusinessOrderCreateBusinessOrder' ||
    to.name == 'wapBusinessOrderSelectProcurementProducts' ||
    to.name == 'wapBusinessOrderAddProducts' ||
    to.name == 'wapBusinessOrderAddProductsSelect' ||
    to.name == 'wapBusinessOrderSelectAddress' ||
    to.name == 'wapBusinessOrderAddAddress' ||
    to.name == 'wapBusinessOrderCreateSuccess' ||
    to.name == 'wapNoticeDetail' ||
    to.name == 'wapScoreIntroduce' ||
    to.name == 'wapFlowDirectionQuery' ||
    to.name == 'wapHelp' ||
    to.name == 'scanCodeBindWechat'
  ) {
    next()
  } else {
    getClientActiveCls().then((res) => {
      if (0 === res.status) {
        let data = res.data
        store.commit('setClientActiveCls', data)
        if (
          to.name === from.name ||
          (to.meta.title && to.meta.title === from.meta.title)
        ) {
          next({
            name: 'redirect',
            query: {
              toPath: to.fullPath
            }
          })
        } else {
          next()
        }
      }
    })
  }
})

router.afterEach((to, from) => {
  if (to.name === 'homePage') {
    store.commit('setSubSelectedKeys', [])
    store.commit('setHideNavbar', true)
    store.commit('setMainSelectedKeys', ['/home'])
  }
  if (to.name === 'flowSystemMyDownload' || to.name === 'userCenter') {
    store.commit('setSubSelectedKeys', [])
    // store.commit('setHideNavbar', true);
    store.commit('setMainSelectedKeys', [])
  }

  // 去除全局加载动画
  setTimeout(() => {
    store.commit('setGlobalLoading', false)
  }, 8000)
})
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  console.error('懒加载：' + error)
  console.error('懒加载：' + targetPath)
  /*if (isChunkLoadFailed) {
    router.replace(targetPath)
  }*/
})

export default router
